import React, { memo, useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  IconButton,
  Typography,
  Stack,
  useMediaQuery,
  TextField,
  Menu,
  MenuItem,
  Tooltip,
  Skeleton,
  CircularProgress,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Iconify, Label, MuiDrawer, NoData, TaskCard } from "src/components";
import { capitalCase } from "change-case";
import { get_zone_date, handle_localSearch } from "src/utils";
import { AnimatePresence, motion } from "framer-motion";
import { useAppContext } from "src/hooks";
import { useTransition } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import TemplateTaskCard from "src/components/task-components/TemplateTaskCard";
const icon_color = "#637381";
// ---------------------------------------------------------
const TaskSections = ({
  handleLoadMoreTasks,
  projectDetail,
  moreTasksLoading,
  workspaceId,
  section,
  onOpenTaskDetail,
  onOpenComments,
  onExpand,
  onChangePriority,
  onChangeStatus,
  onChangeDate,
  onSetSelectedTask,
  projectTeam,
  onMakeSectionDefault,
  onChangeMembers,
  onDelTask,
  onDelSection,
  onEditSection,
  onMoveSection,
  onMoveTask,
  projectSections,
  onDragEnd,
  onDragStart,
  // role,
  allowDrag,
}) => {
  const navigate = useNavigate();
  const { dispatch_get_user_profile } = useAppContext();
  const userProfile = dispatch_get_user_profile();
  const role = projectDetail.role;
  const { enqueueSnackbar } = useSnackbar();
  const [showTasks, setShowTasks] = useState(false);
  const [isPending, startTransition] = useTransition();
  const matches_break_point = useMediaQuery("(max-width:600px)");
  const [menuOpen, setMenuOpen] = useState(false);
  const { section_title, task } = section;
  const { dispatch_get_search_value } = useAppContext();
  const params = useParams();
  const menu_item_icon_size = { height: "1rem", width: "1rem" };
  const handleChange = (section) => {
    //solution working for performance!
    // if (section.expanded === false) {
    //   startTransition(() => {
    //     setShowTasks(true);
    //   });
    // }
    // if (section.expanded === true) {
    //   setShowTasks(false);
    // }
    onExpand(section);
  };
  const getFilteredTasks = () => {
    let search = dispatch_get_search_value();
    return handle_localSearch(search, task);
  };
  const getProjectTeam = () => {
    if (projectTeam) {
      return projectTeam;
    } else {
      return [];
    }
  };
  const getProjectSections = () => {
    if (projectSections) {
      return projectSections.filter(
        (item) => String(item._id) !== String(section._id)
      );
    } else {
      return [];
    }
  };
  const handleOpenMenu = (e) => {
    console.log(section, "section");
    setMenuOpen(e.currentTarget);
  };
  const handleCloseMenu = (e) => {
    setMenuOpen(null);
  };
  const getVariant = (task) => {
    // if (role === "admin") {
    //   return "default";
    // }
    // if (role === "manager") {
    //   return "default";
    // }
    // if (task.creator_profile.user_id === userProfile.user_id) {
    //   return "default";
    // }
    // if (task.user_task_status === true) {
    //   return "default";
    // }
    return "default";
  };
  const handleAction = (action, data) => {
    console.log(action, data, "action + data");
    if (action === "change_status") {
      onChangeStatus(data, workspaceId);
    }
    if (action === "change_priority") {
      onChangePriority(data, workspaceId);
    }
    if (action === "change_date") {
      onChangeDate(data, workspaceId);
    }
    if (action === "change_members") {
      onChangeMembers(data, workspaceId);
    }
    if (action === "del_task") {
      onDelTask(data, workspaceId);
    }
    if (action === "move_task") {
      onMoveTask(data, workspaceId);
    }
    if (action === "drag_end") {
      onDragEnd(data, workspaceId);
    }
    if (action === "drag_start") {
      onDragStart(data, workspaceId);
    }
    if (action === "copy_task_link") {
      handleCopyTaskLink(data);
    }
  };
  const unsecuredCopyToClipboard = (text) => {
    /**
     * Copies the text passed as param to the system clipboard
     * Check if using HTTPS and navigator.clipboard is available
     * Then uses standard clipboard API, otherwise uses fallback
     */
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      enqueueSnackbar("Task link copied to clipboard", {
        variant: "success",
      });
    } catch (err) {
      console.error("Unable to copy to clipboard", err);
      enqueueSnackbar("Failed to copy task link", {
        variant: "error",
      });
    }
    document.body.removeChild(textArea);
  };

  const handleCopyTaskLink = async (task) => {
    const { section_id, _id } = task;
    let project_id = params.id;
    console.log(task, "to-copy");
    let newLink = "";
    newLink = `${window.location.origin}/workspaces/copied-task-link/${project_id}/${section_id}/${_id}`;
    console.log(newLink);
    // unsecuredCopyToClipboard(newLink);
    let has_error = "";
    try {
      await window.navigator.clipboard.writeText(newLink);
    } catch (error) {
      if (error) {
        if (error.message) {
          has_error = error.message;
        }
      }
      enqueueSnackbar("Something went wrong!", { variant: "error" });
    }
    if (has_error === "") {
      enqueueSnackbar("Task link copied to clipboard", { variant: "success" });
      return;
    }
    enqueueSnackbar("Could not copy task link", { variant: "error" });
  };
  const onDel = (type) => {
    onDelSection(section, type);
    handleCloseMenu();
  };
  const onEdit = () => {
    handleCloseMenu();
    onEditSection(section);
  };
  const onMove = (type) => {
    handleCloseMenu();
    const data = { source_section: section, type: type };
    onMoveSection(data);
    //
  };
  const onDefault = () => {
    handleCloseMenu();
    onMakeSectionDefault(section);
    //
  };
  const getListStyle = (isDraggingOver) => {
    if (isDraggingOver) {
      return {
        backgroundColor: "#68ffa7",
      };
    } else {
      return {};
    }
    //
  };
  const getItemStyle = (isDraggingOver, draggablePropsStyle) => {
    if (isDraggingOver) {
      return {
        opacity: "40%",
        backgroundColor: "#68ffa7",
        ...draggablePropsStyle,
      };
    } else {
      return { ...draggablePropsStyle };
    }
    //
  };
  const handleDragEnd = (result) => {
    const data = { section: section, dragResult: result };
    const { draggableId, destination } = result;
    if (!draggableId) {
      console.log("no draggable id drag-end");
      return;
    }
    if (!destination) {
      console.log("no destination drag-end");
      return;
    }
    handleAction("drag_end", data);
    //
  };
  const handleDragStart = (result, task) => {
    const data = { section: section, dragResult: result };
    const { draggableId, destination } = result;
    if (!draggableId) {
      console.log("no draggable id drag-start");
      return;
    }
    if (!destination) {
      console.log("no destination drag-start");
      return;
    }
    handleAction("drag_start", data);
    //
  };
  const handleExpand = () => {
    if (section.expanded === false) {
      setShowTasks(section.expanded);
    }
    if (section.expanded === true) {
      startTransition(() => {
        setShowTasks(section.expanded);
      });
    }
  };
  const handleScroll = () => {
    const elm = document.getElementById(section._id);
    if (elm) {
      if (section.scroll_to_view === true) {
        elm.scrollIntoView({ block: "center", behavior: "auto" });
        // navigate(location.pathname, { state: null });
      }
    }
  };
  useEffect(() => {
    handleScroll();
  }, []);
  // ---------------------------------------------------------
  return (
    <Stack
      className="task-section-parent"
      id={section._id}
      direction="row"
      alignItems="center"
      width={1}
    >
      <Grid container width={1}>
        <Grid item xs={12}>
          <Accordion
            disableGutters
            square={false}
            expanded={section.expanded}
            onChange={(e) => handleChange(section)}
            sx={{ width: "100%" }}
          >
            <AccordionSummary
              style={{ width: "100%", paddingRight: "0px" }}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography
                sx={{ color: (theme) => theme.palette.primary.main }}
                fontWeight="bold"
              >
                {section_title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack spacing={2}>
                <DragDropContext
                  onDragEnd={handleDragEnd}
                  onDragStart={handleDragStart}
                >
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        // style={getListStyle(snapshot.isDraggingOver)}
                      >
                        <AnimatePresence layout initial={false}>
                          {getFilteredTasks().map((task, index) => {
                            return (
                              <motion.div
                                key={task._id}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.2 }}
                                exit={{ opacity: 0 }}
                                layout
                              >
                                <Draggable
                                  isDragDisabled={!allowDrag}
                                  key={task._id}
                                  draggableId={task._id}
                                  index={index}
                                >
                                  {(provided, snapshot) => (
                                    <Stack
                                      {...provided.draggableProps}
                                      // {...provided.dragHandleProps}
                                      ref={provided.innerRef}
                                      width={1}
                                      sx={{
                                        position: "relative",
                                        mb: 2,
                                      }}
                                      direction="row"
                                      alignItems="center"
                                    >
                                      <TemplateTaskCard
                                        task={task}
                                        key={index}
                                        onSetSelectedTask={(task) =>
                                          onSetSelectedTask({
                                            ...task,
                                            sectionData: section,
                                          })
                                        }
                                        variant={getVariant(task)}
                                        projectTeam={getProjectTeam()}
                                        projectSections={getProjectSections()}
                                        onOpenDetail={(task) =>
                                          onOpenTaskDetail(task, workspaceId)
                                        }
                                        onOpenComments={(task) =>
                                          onOpenComments(task, workspaceId)
                                        }
                                        onTaskAction={(action, data) =>
                                          handleAction(action, data)
                                        }
                                        taskSection={section}
                                        isDraggingOver={snapshot.isDragging}
                                        currentUserRole={role}
                                      />
                                      <div className="drag-btn">
                                        {allowDrag === true ? (
                                          <IconButton
                                            {...provided.dragHandleProps}
                                            sx={{ p: "3px" }}
                                          >
                                            <Iconify
                                              sx={{
                                                color: icon_color,
                                              }}
                                              icon="fluent:re-order-dots-vertical-24-filled"
                                            />
                                          </IconButton>
                                        ) : (
                                          <Tooltip title="Not allowed">
                                            <span>
                                              <IconButton
                                                {...provided.dragHandleProps}
                                                sx={{ p: "3px" }}
                                                disabled={true}
                                              >
                                                <Iconify
                                                  sx={{
                                                    color: (theme) =>
                                                      theme.palette.text
                                                        .disabled,
                                                  }}
                                                  icon="fluent:re-order-dots-vertical-24-filled"
                                                />
                                              </IconButton>
                                            </span>
                                          </Tooltip>
                                        )}
                                      </div>
                                    </Stack>
                                  )}
                                </Draggable>
                              </motion.div>
                            );
                          })}
                          {provided.placeholder}
                        </AnimatePresence>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                {section.task.length !== 0 &&
                  section.task_count > section.task.length && (
                    <LoadingButton
                      sx={{ width: "20%", margin: "auto !important" }}
                      onClick={() =>
                        handleLoadMoreTasks(
                          section.load_more_tasks,
                          section._id
                        )
                      }
                      loading={moreTasksLoading}
                      loadingPosition="end"
                      endIcon={<ExpandMoreIcon />}
                      variant="outlined"
                    >
                      More Tasks
                    </LoadingButton>
                  )}
                <NoData
                  dataLength={getFilteredTasks().length}
                  loading={task.length == 0 && section.task_count > 0}
                  taskSection={true}
                  title="No Tasks Found"
                />
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
      <Stack
        direction="row-reverse"
        alignItems="center"
        spacing={0.4}
        sx={{ position: "absolute", top: "14px", right: "22px" }}
      >
        <IconButton
          disableRipple
          sx={{ p: 0, "&:hover": { bgcolor: "transparent" } }}
          onClick={handleOpenMenu}
        >
          <Iconify icon="fluent:more-vertical-24-filled" />
        </IconButton>

        <Label
          sx={{
            bgcolor: (theme) => theme.palette.primary.main,
            color: "white",
          }}
          variant="ghost"
          color="success"
        >
          {section.task_count}
        </Label>
        {section.is_default === true && (
          <div style={{ marginRight: "7px" }}>
            <Label
              sx={{
                bgcolor: (theme) => theme.palette.primary.main,
                color: "white",
              }}
              variant="ghost"
              color="success"
            >
              Default
            </Label>
          </div>
        )}
      </Stack>

      <Menu
        anchorEl={menuOpen}
        open={Boolean(menuOpen)}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          p: 0.5,
          mt: 1,
          "& .MuiMenuItem-root": {
            typography: "body2",
            borderRadius: 0.5,
            mx: 0.5,
          },
        }}
      >
        {!section.is_default && (
          <MenuItem onClick={onDefault}>
            Make Default
            <span style={{ marginLeft: "auto" }}>
              <Iconify
                sx={{ ml: "8px", ...menu_item_icon_size }}
                icon="ic:round-settings"
              />
            </span>
          </MenuItem>
        )}
        <MenuItem onClick={onEdit}>
          Edit
          <span style={{ marginLeft: "auto" }}>
            <Iconify
              sx={{ ml: "8px", ...menu_item_icon_size }}
              icon="ic:baseline-mode-edit"
            />
          </span>
        </MenuItem>
        {section.is_default === false && (
          <MenuItem onClick={() => onDel("without_tasks")}>
            Delete
            <span style={{ marginLeft: "auto" }}>
              <Iconify
                sx={{ ml: "8px", ...menu_item_icon_size }}
                icon="dashicons:trash"
              />
            </span>
          </MenuItem>
        )}
        {/* {section.is_default === false && (
          <MenuItem onClick={() => onDel("with_tasks")}>
            Delete With Tasks
            <span style={{ marginLeft: "auto" }}>
              <Iconify
                sx={{ ml: "8px", ...menu_item_icon_size }}
                icon="dashicons:trash"
              />
            </span>
          </MenuItem>
        )} */}
        <MenuItem
          onClick={() => onMove("up")}
          disabled={section.move_up === false}
        >
          Move Up
          <span style={{ marginLeft: "auto" }}>
            <Iconify
              sx={{ ml: "8px", ...menu_item_icon_size }}
              icon="akar-icons:arrow-up"
            />
          </span>
        </MenuItem>
        <MenuItem
          onClick={() => onMove("down")}
          disabled={section.move_down === false}
        >
          Move Down
          <span style={{ marginLeft: "auto" }}>
            <Iconify
              sx={{ ml: "8px", ...menu_item_icon_size }}
              icon="akar-icons:arrow-down"
            />
          </span>
        </MenuItem>
      </Menu>
    </Stack>
  );
};
const TaskSection = memo(TaskSections);
export default TaskSection;
